import * as lvFlandersDigitaalDossierNgUi from '../../../dist/@lvflanders/digitaaldossier-ng-ui';

// global glue variable for externals
if (window['lvflanders'] == null) window['lvflanders'] = <any>{};
if (window['lvflanders'].digitaaldossier == null) window['lvflanders'].digitaaldossier = <any>{};
if (window['lvflanders'].digitaaldossier.ng == null) window['lvflanders'].digitaaldossier.ng = <any>{};

window['lvflanders'].digitaaldossier.ng.ui = lvFlandersDigitaalDossierNgUi;

export { lvFlandersDigitaalDossierNgUi };
